import { useTranslation } from "react-i18next";

import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { ProgressSpinner } from "primereact/progressspinner";

import {
  IDisclaimersFormProps,
  IDisclaimerTranslationKeys,
} from "../../../../models/interfaces/disclaimers-tab.interface";
import { DisclaimerLanguage, DisclaimerTexts } from "../../../../models/types/disclaimer.type";
import { DISCLAIMER_LANGUAGES } from "./useDisclaimersTabState";

import "./DisclaimersForm.scss";

export const DisclaimersForm = (props: IDisclaimersFormProps) => {
  const { t } = useTranslation();
  const {
    loading,
    saving,
    bingTexts,
    imageGenTexts,
    commonTranslationKeys,
    bingTranslationKeys,
    imageGenTranslationKeys,
    hasChanges,
    onChangeBing,
    onChangeImageGen,
    onSave,
    onReset,
  } = props;

  const renderDisclaimerSection = (
    title: string,
    texts: DisclaimerTexts,
    translationKeys: IDisclaimerTranslationKeys,
    onChange: (language: DisclaimerLanguage, value: string) => void,
  ) => {
    return (
      <div className="disclaimer-section">
        <h3 className="section-title">{title}</h3>
        {DISCLAIMER_LANGUAGES.map(language => {
          const languageName = t(`languages.${language}`, { defaultValue: language });
          const languageCode = language.toUpperCase();

          return (
            <div className="field-row" key={language}>
              <label className="field-label">{t(commonTranslationKeys.label, { languageCode })}</label>

              <InputTextarea
                value={texts[language].text}
                onChange={e => onChange(language, e.target.value)}
                rows={5}
                autoResize
                placeholder={t(translationKeys.placeholder, {
                  languageCode,
                  languageName,
                })}
              />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="disclaimer-tab">
      {loading ? (
        <div className="disclaimer-loading">
          <ProgressSpinner />
        </div>
      ) : (
        <div className="disclaimer-form">
          {renderDisclaimerSection(t(bingTranslationKeys.tabLabel), bingTexts, bingTranslationKeys, onChangeBing)}

          {renderDisclaimerSection(
            t(imageGenTranslationKeys.tabLabel),
            imageGenTexts,
            imageGenTranslationKeys,
            onChangeImageGen,
          )}

          <div className="disclaimer-actions">
            <Button
              label={t(commonTranslationKeys.actions.save)}
              icon="pi pi-check"
              onClick={onSave}
              disabled={!hasChanges || saving}
            />

            <Button
              label={t(commonTranslationKeys.actions.reset)}
              icon="pi pi-refresh"
              onClick={onReset}
              className="p-button-secondary"
              disabled={!hasChanges || saving}
            />
          </div>
        </div>
      )}
    </div>
  );
};
